<div class="ent_but">
  <div class="wrap d-flex align-items-center gap-2">
    <input type="checkbox" class="hidsn" id="s4" name="persiste" [(ngModel)]="persistValue" />
    <label class="slider-v2" for="s4"></label>
    <span>{{ 'warehouse.newMovement.keepValues' | translate }}</span>
  </div>

  <div class="col-chooser">
    <button type="button" class="btn btn-sm btn-secondary d-flex align-items-center gap-1"
            (click)="columnMenuOpen = !columnMenuOpen; $event.stopPropagation();">
      {{ 'common.columns' | translate }}
      <mat-icon style="font-size: 18px;">expand_more</mat-icon>
    </button>
    <div class="col-chooser-panel" *ngIf="columnMenuOpen" (click)="$event.stopPropagation()">
      <label class="col-chooser-item d-flex align-items-center gap-2"
             *ngFor="let field of collapsibleColumns()">
        <input type="checkbox" [checked]="isColumnVisible(field)" (change)="toggleColumn(field)">
        <span>{{ field }}</span>
      </label>
    </div>
  </div>
</div>

<ng-container *ngIf="tableData && tableData.data">


  <ng-container *ngIf="tableData && tableData.data.length > 0; else nada">
    <ngx-syncscroll [classSyncScroll]="'scroller'" [dragState]="false" [attributeName]="'synced'">
      <cdk-virtual-scroll-viewport *ngIf="productStructure" scrollWindow itemSize="108" class="__sd_sd">

      <table class="table table-borderless table-sm m-0 smsm_ "
        *ngIf="productStructure && productStructure.stockfields && productStructure.stockfields.length > 0 && productStructure.fields && productStructure.fields.length > 0 ">

          <thead class="th_ead" [ngClass]="{ 'fixed-header': true }" [style.top]="inverseTranslation">
            <div [ngClass]="'scroller'" [attr.synced]="true" style="overflow: auto">
              <tr class="d-flex w-100 justify-content-between align-items-center">
                <th scope="col" class="d-flex col-select" style="justify-content: center;">
                  <div class="d-flex flex-column gap-1 align-items-start">
                    <div class="d-flex">{{ 'common.all' | translate }}</div>
                    <div class="d-flex">
                      <div class="checkbox-wrapper-31 checkbox-wrapper-32">
                        <input checked="" type="checkbox" name="all" [(ngModel)]="productSelectAll" id="all_ch">

                        <svg viewBox="0 0 35.6 35.6">
                          <circle class="background" cx="17.8" cy="17.8" r="17.8"></circle>
                          <circle class="stroke" cx="17.8" cy="17.8" r="14.37"></circle>
                          <polyline class="check" points="11.78 18.12 15.55 22.23 25.17 12.87"></polyline>
                        </svg>

                      </div>
                    </div>
                  </div>
                </th>

                <th scope="col" class="d-flex col-image">{{ 'common.image' | translate }}</th>

                <th scope="col" class="d-flex justify-content-center col-name">

                  <app-sort-header [direction]="sortDirection('name')" [sortable]="!noPaginationAndSort"
                                   [rank]="sortRank('name')" [rankDirection]="sortRankDirection('name')"
                                   (sort)="setSort({$field: 'name',  $editable: false,  $label: 'name',  $sortable: true, $id: 'name'})">
                  <span style=" display: flex" [ngStyle]="{cursor: noPaginationAndSort ? 'not-allowed' : 'pointer'  }">
                    {{ 'common.name' | translate }}
                    <span aria-hidden="true" style=" display: flex" [ngStyle]="{cursor: noPaginationAndSort ? 'not-allowed' : 'pointer'  }"
                          matBadgeSize="small" *ngIf="sortStatus['name']" matBadgePosition="before" matBadgeColor="accent"
                          [matBadge]="sortStatus['name'].position + 1">
                      <mat-icon style="font-size: 20px !important; ">
                        {{sortStatus['name'].direction == 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down'}}
                      </mat-icon>
                    </span>

                  </span>

                  </app-sort-header>
                </th>

                <ng-container *ngFor="let f of productStructure.fields; index as ffIndex">
                  <ng-container *ngIf="f && f.field && f.field != 'reserved' ">

                    <th scope="col" class="d-flex justify-content-center col-field" [class.col-hidden]="!isColumnVisible(f.field)">

                      <app-sort-header [direction]="sortDirection(f.field + '.id')" [sortable]="!noPaginationAndSort"
                                       [rank]="sortRank(f.field + '.id')" [rankDirection]="sortRankDirection(f.field + '.id')"
                                       (sort)="setSort({$field: f.field + '.id',  $editable: false,  $label: f.field,  $sortable: true, $id: f.field + '.id' })">
                      <span style=" display: flex" [ngStyle]="{cursor: noPaginationAndSort ? 'not-allowed' : 'pointer'  }">
                        {{f.field}}
                        <span aria-hidden="true" style=" display: flex" [ngStyle]="{cursor: noPaginationAndSort ? 'not-allowed' : 'pointer'  }"
                              matBadgeSize="small" *ngIf="sortStatus[f.field + '.id']" matBadgePosition="before"
                              matBadgeColor="accent" [matBadge]="sortStatus[f.field + '.id'].position + 1">
                          <mat-icon style="font-size: 20px !important; ">
                            {{sortStatus[f.field + '.id'].direction == 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down'}}
                          </mat-icon>
                        </span>

                      </span>
                      </app-sort-header>
                    </th>

                  </ng-container>

                </ng-container>

                <th scope="col" class="d-flex col-number">

                  <app-sort-header [direction]="sortDirection('number')" [sortable]="!noPaginationAndSort"
                                   [rank]="sortRank('number')" [rankDirection]="sortRankDirection('number')"
                                   (sort)="setSort({$field: 'number',  $editable: false,  $label: 'number',  $sortable: true, $id: 'number', $sortExpression: 'numberOrder'})">
                  <span style="display: flex" [ngStyle]="{cursor: noPaginationAndSort ? 'not-allowed' : 'pointer'  }">
                    {{ 'common.number' | translate }}
                    <span aria-hidden="true" style="display: flex" [ngStyle]="{cursor: noPaginationAndSort ? 'not-allowed' : 'pointer'  }"
                          matBadgeSize="small" *ngIf="sortStatus['number']" matBadgePosition="before" matBadgeColor="accent"
                          [matBadge]="sortStatus['number'].position + 1">

                      <mat-icon style="font-size: 20px !important; ">
                        {{sortStatus['number'].direction == 'ASC' ? 'arrow_drop_up' : 'arrow_drop_down'}}
                      </mat-icon>

                    </span>
                  </span>
                  </app-sort-header>
                </th>

                <ng-container *ngFor="let field of productStructure?.stockfields; index as idNon">
                  <ng-container *ngIf="field.field && field.type == 'LOOKUP'">
                    <th scope="col" class="d-flex">
                      <div class="d-flex col-dual">

                        <!-- aqui 1 -->
                        <app-structure-rapid-look-up-field-normal class="w-100" (getValues)="getValues($event, field)"
                                                                  (loadFailed)="headerLookupLoadFailed($event)"
                                                                  [name]="field.field + '_' + field.type + idNon" [structureField]="field"
                                                                  [resetAll]="resetValueOnFireObs"
                                                                  [valueSet]="productGestioneFieldsAll(field.field + 'Row').productFieldAll"
                                                                  [(ngModel)]="productGestioneFieldsAll(field.field + 'Row').productFieldAll">
                        </app-structure-rapid-look-up-field-normal>
                      </div>
                    </th>
                  </ng-container>

                  <ng-container *ngIf="field.field && field.type == 'FLAG'">
                    <th scope="col" class="d-flex col-flag" [class.col-hidden]="!isColumnVisible(field.field)">
                      <div class=" d-flex ">
                        <!-- A toggle, so a real <button> with aria-pressed: the bare <img (click)> had
                             no tab stop, no Enter/Space and no role (WCAG 2.1.1 / 4.1.2; refused by
                             `npm run audit:pointeronly`). The name is the FLAG, never the field object
                             ([alt]="field" once stringified to "[object Object]"), and it is the same
                             string as the tooltip, so CDK does not describe it a second time. It stays
                             the flag's name in both states: only aria-pressed carries the state. The
                             on/off look stays on the <img>, so the dimming never fades the focus ring. -->
                        <button type="button" class="g15-img-control" (click)="setValueFieldAll(field)"
                                [attr.aria-pressed]="!!valueFiledAll[field.field]"
                                [matTooltip]="flagLabel(field)" [attr.aria-label]="flagLabel(field)">
                          <img width="30" height="30" [src]="getImagePath(field) || ''" alt="" class="agg_img"
                               [ngClass]="{'black_all' : !valueFiledAll[field.field], 'color_all': valueFiledAll[field.field]   }">
                        </button>
                      </div>
                    </th>
                  </ng-container>
                </ng-container>

                <th scope="col" class="d-flex col-narrow">
                  <input type="text" name="allComments" [placeholder]="'common.comments' | translate" [(ngModel)]="commentsAll" class="fixNormal_">
                </th>

                <th scope="col" class="d-flex col-dual">
                  <div class="d-flex col-dual">
                    <div class="d-flex flex-row p-0 m-0 contingenci">
                      <div class="d-flex inp_">
                        <div class="d-flex position-relative">
                          <input type="number" [min]="0" #genericFieldAll="ngModel" class="w-100"
                                 (wheel)="onWheel($event)"
                                 [(ngModel)]="entityValueAll" [placeholder]="'common.warehouse' | translate" autocomplete="off" required />

                          <span *ngIf="!errorCustomAll && entityAll" class="errorVola">{{ warehouseHintLabel(entityAll) }}</span>
                        </div>
                      </div>
                      <div class="d-flex selt_">
                        <select class="form-select form-select-sm w-100" [(ngModel)]="entityValueAll"
                                [compareWith]="compareEntity" [attr.aria-label]="'common.aria.formSelect' | translate">
                          <option selected></option>
                          <option style="color: var(--g15-on-surface-inverse);" *ngFor="let ent of warehouseOptions(dataExtra['warehouses'])" [value]="ent.id"
                                  [attr.title]="warehouseOptionTitle(ent) || null">
                            {{ warehouseOptionLabel(ent) }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </th>

                <th scope="col" class="d-flex col-narrow">
                  <input type="text" appNumberInput="integer" name="allQuantity" class="fixNormal_" [placeholder]="'common.quantity' | translate"
                         [(ngModel)]="quantityAll" #allQuantityRef="ngModel" [class.is-invalid]="allQuantityRef.invalid && allQuantityRef.dirty"
                         [min]="1" (ngModelChange)="validInput(undefined, $event)">

                </th>

                <th scope="col" class="d-flex col-narrow">
                  <input type="text" appNumberInput [maxDecimals]="2" name="allpurchasePrice" class="fixNormal_"
                         [placeholder]="'common.purchasePrice' | translate" [(ngModel)]="purchasePriceModel"
                         #allPurchasePriceRef="ngModel" [class.is-invalid]="allPurchasePriceRef.invalid && allPurchasePriceRef.dirty" [min]="0"
                         (ngModelChange)="validInputDouble(undefined, $event)">

                </th>

                <th scope="col" class="d-flex col-actions" style="min-height: 64px;">
                  <div class="d-flex flex-column justify-content-center align-items-center gap-1 w-100">
                    <div class="d-flex">
                      {{ 'common.table.actions' | translate }}
                    </div>

                    <div class="d-flex justify-content-center gap-1 w -100">
                      <div class="d-flex align-items-center">

                        <ng-container *ngIf="allsValid() && allsValidValue ;">
                          <ng-container *ngIf="!loadAll; else loadingAllTem; ">
                            <!-- setAll() raises loadAll itself, and only when it actually dispatches a save:
                                 a press it refuses (bulk already in flight, or every counted row dropped out
                                 between press and snapshot) must not strand the spinner with no request out. -->
                            <button type="button" (click)="setAll(); $event.preventDefault(); "
                                    class="btn btn-outline-success btn-sm">
                              {{ allsValidValue != undefined ? ((allsValidValue > 1 ? 'common.table.editRows.saveItems.many' : 'common.table.editRows.saveItems.one') | translate: { count: allsValidValue }) : '' }}
                            </button>
                          </ng-container>
                          <ng-template #loadingAllTem>
                            <div>
                              <mat-spinner mode="indeterminate" diameter="30" style="padding: 0"></mat-spinner>
                            </div>

                          </ng-template>
                        </ng-container>


                      </div>

                    </div>
                  </div>
                </th>
              </tr>
            </div>
          </thead>

        <div [ngClass]="'scroller'" [attr.synced]="true" style="overflow: hidden;">
            <!-- ! BODY TABLE -->
            <tbody class="d-flex w-100 justify-content-between flex-column"
              [ngStyle]="{'padding': loadingAll ? 'inherent' : '10px' }"
              *ngIf=" ( loadingAll || loadingType['MULTIPLE'] ) ; else loadingTemplate">

              <tr class="search-results" *cdkVirtualFor="let item of copyProducts ; let is = index;"
                [ngClass]="is % 2 === 0 && item.active ? 'selectedRowPair' : item.active ? 'selectedRowNotPair' : ''">

                <!-- productSelectValue[is] || -->

                <ng-container *ngIf=" loadingAll && productStructure
                  && item.warehouses && item.warehouses.length > 0
                  && item.languages && item.languages.length > 0
                  && item.conditions && item.conditions.length  ;">

                  <!-- item.conditions && item.conditions.length > 0 && item.languages && item.languages.length > 0 &&-->

                  <td class="col-select" style="justify-content: center;">
                    <div class="d-flex align-items-center">
                      <div class="checkbox-wrapper-31">
                        <input checked="" type="checkbox" name="selectProduct_{{ is }}"
                          [(ngModel)]="productGestione(is, false, item.id).productSelect" id="is">
                        <svg viewBox="0 0 35.6 35.6">
                          <circle class="background" cx="17.8" cy="17.8" r="17.8"></circle>
                          <circle class="stroke" cx="17.8" cy="17.8" r="14.37"></circle>
                          <polyline class="check" points="11.78 18.12 15.55 22.23 25.17 12.87"></polyline>
                        </svg>
                      </div>
                    </div>
                  </td>

                  <td class="col-image">

                    <div class="d-flex align-items-center">
                      <!-- The thumbnail opens the zoom, so it is a real <button> (WCAG 2.1.1 / 4.1.2;
                           `npm run audit:pointeronly`), named for what it does; the <img> inside is
                           decorative so the card's name is not read twice. The card's name is
                           resolved ONCE per row (localizedName is impure and this grid is hot) and
                           the label serves as name and tooltip alike -- the same string, so CDK does
                           not describe the control a second time. (detach) resyncs isOpen however
                           the zoom closed: CDK detaches on Escape by itself. -->
                      <ng-container *ngIf="{ name: item.cardData | localizedName } as c">
                      <ng-container *ngIf="{ label: c.name ? ('common.actions.enlargeImageNamed' | translate: { name: c.name }) : ('common.actions.enlargeImage' | translate) } as v">
                      <button type="button" class="g15-img-control" #trigger="cdkOverlayOrigin" cdkOverlayOrigin
                        (click)="showImage(is); $event.stopPropagation()" [attr.aria-expanded]="!!isOpen[is]"
                        [attr.aria-label]="v.label" [matTooltip]="v.label">
                        <img class="agg_img" [src]="item.cardData.image | appImageUrl" alt="" width="40"
                          (error)="noImage(item)" height="50" />
                      </button>

                      <ng-template #cdkConOverlay="cdkConnectedOverlay" cdkConnectedOverlay
                        [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen[is]"
                        (detach)="isOpen[is] = false">
                        <div class="d-flex panel_onfire justify-content-center flex-column align-items-center w-100">
                          <div class="d-flex w-100" style="max-width: 200px">
                            <!-- alt names the card, never the stored path: that path is nullable,
                                 and a nullish [alt] makes Angular drop the attribute, leaving
                                 this zoomed thumbnail with no accessible name. -->
                            <img [src]="item['cardData']['image'] | appImageUrl" [alt]="c.name || ''"
                              (error)="noImage(item)" width="200" height="300" />
                          </div>
                        </div>
                      </ng-template>
                      </ng-container>
                      </ng-container>

                    </div>
                  </td>

                  <td class="col-name">
                    <div class="d-flex w-100 justify-content-center">
                      <span>{{ item["name"] }}</span>
                    </div>
                  </td>

                  <ng-container *ngFor="let f of productStructure.fields; index as ffIndex">
                    <ng-container *ngIf="f && f.field && f.field != 'reserved'">
                      <td class="col-field" [class.col-hidden]="!isColumnVisible(f.field)">
                        <div class="d-flex w-100 justify-content-center" *ngIf="item[f.field]">

                          <ng-container *ngIf="f.field == 'color'">
                            <span
                              [ngStyle]=" {'width' : '20px', 'height': '20px', 'background-color' : showColor( item['color']['name'] ), 'border-radius': '15px' } "></span>
                          </ng-container>


                          <div class="module line-clamp" matTooltip="{{   item[f.field]['name'] }}">
                            <span> {{ item[f.field]['name'] }} </span>
                          </div>

                        </div>
                      </td>
                    </ng-container>
                  </ng-container>

                  <td class="col-number">
                    <div class="d-flex">
                      <span>{{ item["number"] }}</span>
                    </div>
                  </td>

                  <ng-container *ngFor="let field of productStructure?.stockfields;">
                    <ng-container *ngIf="field.field && field.type == 'LOOKUP'">

                      <td *ngIf="field.field == 'language' ">
                        <div class="d-flex col-dual" *ngIf="item.languages && item.languages.length > 0">

                          <div class="d-flex col-dual">

                            <div class="d-flex flex-row p-0 m-0 contingenci align-items-center">
                              <div class="d-flex inp_ flex-column position-relative align-items-center h-100">
                                <form #form_sL="ngForm" class="d-flex h-100 w-100">

                                  <!-- [ngClass]="{'error': errorCustomLingua[is + '_' + item.id] }" -->

                                  <input type="number" [min]="0" #inputLanguage
                                    (wheel)="onWheel($event)" class="w-100 h-100"
                                    [name]="is + '_' + item.id "
                                    [(ngModel)]="productGestione(is, true, item.id, inputLanguage ).entityValueLingua"
                                    [placeholder]="'common.language' | translate" autocomplete="off" required="true" />

                                  <!-- <span *ngIf="errorCustomLingua[is + '_' + item.id]" class="errorVola">error value</span> -->
                                  <span *ngIf="!(errorCustomLingua[is + '_' + item.id]) && item['languageRow']"
                                    class="errorVola">{{item['languageRow']?.name}}</span>

                                </form>

                              </div>

                              <div class="d-flex selt_ h-100">
                                <select required class="form-select form-select-sm w-100 h-100"
                                  [name]="is + '_' + item.id + field.field + '_select' "
                                  [(ngModel)]="productGestione(is, true, item.id).entityValueLingua"
                                  [compareWith]="compareEntity" [attr.aria-label]="'common.aria.formSelect' | translate">
                                  <option selected></option>
                                  <option style="color: var(--g15-on-surface-inverse);" *ngFor="let ent of item.languages" [value]="ent.id">
                                    {{ent.id}} - {{getEntitiesDescription(ent)}}
                                  </option>
                                </select>
                              </div>

                            </div>
                          </div>
                        </div>
                      </td>

                      <td *ngIf="field.field == 'condition' ">
                        <div class="d-flex col-dual" *ngIf="item.conditions && item.conditions.length > 0">

                          <div class="d-flex col-dual">

                            <div class="d-flex flex-row p-0 m-0 contingenci align-items-center">
                              <div class="d-flex inp_ flex-column position-relative align-items-center h-100">
                                <form #form_sC="ngForm" class="d-flex h-100 w-100">

                                  <!-- [ngClass]="{'error': errorCustomCondizione[is + '_' + item.id] }" -->

                                  <input type="number" [min]="0" #inputCondition
                                    (wheel)="onWheel($event)" class="w-100 h-100"
                                    [name]="is + '_' + item.id "
                                    [(ngModel)]="productGestione(is, true, item.id, inputCondition ).entityValueCondition"
                                    [placeholder]="'common.condition' | translate" autocomplete="off" required="true" />

                                  <span *ngIf="errorCustomCondizione[is + '_' + item.id]" class="errorVola">{{ 'common.table.editRows.errors.valueInvalid' | translate }}</span>
                                  <span *ngIf="!(errorCustomCondizione[is + '_' + item.id]) && item['conditionRow']"
                                    class="errorVola">{{item['conditionRow']?.name}}</span>

                                </form>

                              </div>

                              <div class="d-flex selt_ h-100">
                                <select required class="form-select form-select-sm w-100 h-100"
                                  [name]="is + '_' + item.id + field.field + '_select' "
                                  [(ngModel)]="productGestione(is, true, item.id).entityValueCondition"
                                  [compareWith]="compareEntity" [attr.aria-label]="'common.aria.formSelect' | translate">
                                  <option selected></option>
                                  <option style="color: var(--g15-on-surface-inverse);" *ngFor="let ent of item.conditions" [value]="ent.id">
                                    {{ent.id}} - {{getEntitiesDescription(ent)}}
                                  </option>
                                </select>
                              </div>

                            </div>
                          </div>
                        </div>
                      </td>

                      <td *ngIf="field.field == 'holo' ">
                        <div class="d-flex col-dual" *ngIf="item.holos && item.holos.length > 0">

                          <div class="d-flex col-dual">

                            <div class="d-flex flex-row p-0 m-0 contingenci align-items-center">
                              <div class="d-flex inp_ flex-column position-relative align-items-center h-100">
                                <form #form_s="ngForm" class="d-flex h-100 w-100">

                                  <input type="number" [min]="0" #inputHolo
                                    (wheel)="onWheel($event)"class="w-100 h-100"
                                    [name]="is + '_' + item.id " [ngClass]="{'error': errorCustomHolo[is + '_' + item.id] }"
                                    [(ngModel)]="productGestione(is, true, item.id, inputHolo ).entityValueHolos"
                                    [placeholder]="'common.holo' | translate" autocomplete="off" required="true" />

                                  <!-- <span *ngIf="errorCustomHolo[is + '_' + item.id]" class="errorVola">error value</span> -->
                                  <span *ngIf="!(errorCustomHolo[is + '_' + item.id]) && item['holoRow']"
                                    class="errorVola">{{item['holoRow']?.name}}</span>

                                </form>

                              </div>

                              <div class="d-flex selt_ h-100">
                                <select required class="form-select form-select-sm w-100 h-100"
                                  [name]="is + '_' + item.id + field.field + '_select' "
                                  [(ngModel)]="productGestione(is, true, item.id).entityValueHolos"
                                  [compareWith]="compareEntity" [attr.aria-label]="'common.aria.formSelect' | translate">
                                  <option selected></option>
                                  <option style="color: var(--g15-on-surface-inverse);" *ngFor="let ent of item.holos" [value]="ent.id">
                                    {{ent.id}} - {{getEntitiesDescription(ent)}}
                                  </option>
                                </select>
                              </div>

                            </div>
                          </div>
                        </div>
                      </td>

                    </ng-container>

                    <ng-container *ngIf="field.field && field.type == 'FLAG'">

                      <td class="col-flag" [class.col-hidden]="!isColumnVisible(field.field)">
                        <div class=" d-flex " *ngIf="field.field">
                          <!-- Same as the header toggle above: a button, named by the flag, state on aria-pressed. -->
                          <button type="button" class="g15-img-control" (click)="setValueField(field, is)"
                                  [attr.aria-pressed]="!!item[field.field]"
                                  [matTooltip]="flagLabel(field)" [attr.aria-label]="flagLabel(field)">
                            <img class="agg_img" width="30" height="30" [src]="getImagePath(field) || ''" alt=""
                              [ngClass]="{'black' : !item[field.field], 'color': item[field.field]  }">
                          </button>
                        </div>
                      </td>

                    </ng-container>
                  </ng-container>

                  <td class="col-narrow">
                    <div class="d-flex maxNormal h-100">
                      <!-- comments -->
                      <input type="text" style="height: 30px" [placeholder]="'common.write' | translate" name="comment_{{ is }}"
                        [(ngModel)]="productGestione(is, true).productComment" />
                    </div>
                  </td>

                  <td>
                    <div class="d-flex col-dual">

                      <div class="d-flex flex-row p-0 m-0 contingenci align-items-center">
                        <div class="d-flex inp_ flex-column position-relative align-items-center h-100">
                          <form #form="ngForm" class="d-flex h-100 w-100">

                            <input type="number" [min]="0" (wheel)="onWheel($event)" (ngModelChange)="getChangeForm(form)" class="w-100 h-100"
                              [name]="is + '_' + item.id" [ngClass]="{'error': errorCustom[is + '_' + item.id] }"
                              [(ngModel)]="productGestione(is, true, item.id).entityValueWarehouse" [placeholder]="'common.warehouse' | translate"
                              autocomplete="off" required="true" />

                            <!-- <span *ngIf="errorCustom[is + '_' + item.id]" class="errorVola">error value</span> -->

                            <span *ngIf="!(errorCustom[is + '_' + item.id]) && item['warehouseRow']"
                              class="errorVola">{{ warehouseHintLabel(item['warehouseRow']) }}</span>

                          </form>
                        </div>
                        <div class="d-flex selt_ h-100">
                          <select [required]="true" class="form-select form-select-sm w-100 h-100"
                            [name]="is + '_' + item.id + '_select' "
                            [(ngModel)]="productGestione(is, true, item.id).entityValueWarehouse"
                            [compareWith]="compareEntity" [attr.aria-label]="'common.aria.formSelect' | translate">
                            <option selected></option>
                            <option style="color: var(--g15-on-surface-inverse);" *ngFor="let ent of warehouseOptions(item.warehouses)" [value]="ent.id"
                                    [attr.title]="warehouseOptionTitle(ent) || null">
                              {{ warehouseOptionLabel(ent) }}
                            </option>
                          </select>
                        </div>

                      </div>
                    </div>
                  </td>

                  <td class="col-narrow">
                    <div class="d-flex maxNormal h-100">
                      <!-- quantity -->
                      <!-- return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57)); -->
                      <input required style="height: 30px" type="text" appNumberInput="integer" [placeholder]="'common.quantity' | translate" [min]="1"
                        (ngModelChange)="validInput(is, $event)"
                        [(ngModel)]="productGestione(is, true).productQuantity" name="quantity_{{ is }} " />
                    </div>
                  </td>

                  <td class="col-narrow">
                    <div class="d-flex maxNormal h-100">
                      <!-- quantity -->
                      <!-- return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57)); -->
                      <input style="height: 30px" type="text" appNumberInput [maxDecimals]="2" [placeholder]="'common.purchasePrice' | translate" [min]="0"
                        (ngModelChange)="validInputDouble(is, $event)"
                        [(ngModel)]="productGestione(is, true).productPurchasePrice" name="purchasePrice_{{ is }} " />
                    </div>
                  </td>

                  <td class="col-actions">
                    <div class="d-flex gap-1 col-actions-inner">

                      <!-- Disabled only while THIS row's own save is in flight, and asked by row
                           rather than by index: deleting a row above a saving one shifts every
                           later index, so an index-keyed flag moved the spinner onto a stranger
                           and handed the in-flight row its save button back. A duplicate/delete
                           landing during a BULK commit needs no guard - rows are remembered by
                           ROW_UID, which survives the deep clone both handlers replace the array
                           with, so the commit's reset() still finds exactly the rows it carried.
                           The tooltip hangs on a wrapping span because a disabled button fires no
                           pointer events and would never show one. -->
                      <span [matTooltip]="'common.actions.duplicate' | translate">
                        <button [disabled]="isRowSaving(item)" type="button" class="btn btn-primary btn-sm"
                          [attr.aria-label]="'common.actions.duplicate' | translate" (click)="clonedRow(is); $event.preventDefault();  ">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-back" viewBox="0 0 16 16">
                            <path
                              d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2z" />
                          </svg>
                        </button>
                      </span>


                      <span [matTooltip]="'common.actions.delete' | translate">
                        <button type="button" [disabled]="isRowSaving(item)" class="btn btn-danger btn-sm"
                          [attr.aria-label]="'common.actions.delete' | translate" (click)="deletedRow(is); $event.preventDefault();">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-trash" viewBox="0 0 16 16">
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                            <path
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                          </svg>
                        </button>
                      </span>


                      <!-- A rendered-but-refused value (a 0/fractional quantity or a negative price
                           from an older build's draft) leaves the row looking savable while every
                           save path excludes it — this icon is the only signal naming the cell to
                           correct. See rowValueWarningKey. -->
                      <span *ngIf="rowValueWarningKey(item) as warnKey" class="text-warning"
                        [matTooltip]="warnKey | translate"
                        [attr.aria-label]="warnKey | translate" role="img">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                          <path
                            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                        </svg>
                      </span>

                      <!-- The brand-6 holo requirement is WAIVED for a row whose product offers no
                           holos, or the operator would fill it completely and no button would ever
                           enable. The waiver is correct and the commit is legitimate — but it books
                           a movement with no variant recorded, so it must not also be invisible:
                           a stale permitted-values filter makes the lookup answer with a genuine
                           empty list, and the only outward sign was the holo cell quietly vanishing.
                           See rowHoloWaivedKey. -->
                      <span *ngIf="rowHoloWaivedKey(item) as holoKey" class="text-info"
                        [matTooltip]="holoKey | translate"
                        [attr.aria-label]="holoKey | translate" role="img">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                          <path
                            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                        </svg>
                      </span>
                      <ng-container *ngIf="isRowSaving(item); else showButton;">
                        <div>
                          <mat-spinner mode="indeterminate" diameter="30" style="padding: 0"></mat-spinner>
                        </div>
                      </ng-container>
                      <ng-template #showButton>
                        <span [matTooltip]="'common.actions.saveRow' | translate">

                          <!-- canSaveRow(), not an inlined `!item.quantity`: that is falsy for NaN but TRUE
                               for Infinity, so this button and the bulk path disagreed about which rows are
                               sendable and only the bulk one refused a non-finite quantity.
                               isRowBulkLocked(), NOT the blanket isBulkSaving(): a row the in-flight bulk
                               snapshotted is not blanked until its success returns, so a press on IT would
                               re-POST the same movement — but a row the bulk never carried is independent
                               work, and a blanket disable silently dropped its press (a disabled button
                               fires no click). -->
                          <button type="submit" [disabled]="!canSaveRow(item) || isRowBulkLocked(item)"
                            [attr.aria-label]="'common.actions.saveRow' | translate"
                            (click)="saveRow(is); $event.preventDefault(); " class="btn btn-success btn-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                              class="bi bi-save" viewBox="0 0 16 16">
                              <path
                                d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                            </svg>
                          </button>
                        </span>
                      </ng-template>
                    </div>
                  </td>
                </ng-container>
              </tr>

            </tbody>
        </div>
      </table>

      <ng-template #loadingTemplate>
        <div class="d-flex flex-column justify-content-center align-items-center p-1 w-100 h-100">
          <div>
            <mat-spinner mode="indeterminate" diameter="90" style="padding: 0"></mat-spinner>
          </div>
        </div>
      </ng-template>

    </cdk-virtual-scroll-viewport>

    </ngx-syncscroll>
  </ng-container>


  <mat-paginator *ngIf="!noPaginationAndSort" class="mat-elevation-z1" style="margin-top: 60px;"
    [pageSize]="tableData.tableStatus.page.length > 0 ?  tableData.tableStatus.page.pageSize : 0"
    [pageIndex]="tableData.tableStatus.page.pageIndex" [showFirstLastButtons]="true"
    [length]="tableData.tableStatus.page.length">
  </mat-paginator>
</ng-container>


<ng-template #nada>
  <div class="d-flex justify-content-center w-100 align-items-center">

    <h2>{{ 'common.table.editRows.empty' | translate }}</h2>

  </div>
</ng-template>
